import { fromJS } from 'immutable'

let defaultState = fromJS({ })

export default function compose (state = defaultState, action) {
  state = fromJS(state) // Force immutable in case of rehydration

  switch (action.type) {
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./client/src/user/reducer.js